import { Component, Input, computed, signal } from '@angular/core';

@Component({
  selector: 'app-tag-chips',
  standalone: false,
  template: `
    @if (tags().length > 0) {
      <div class="flex flex-wrap items-center gap-1">
        @for (tag of visibleTags(); track tag) {
          <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-primary-50 text-primary-700 border border-primary-100 whitespace-nowrap">
            {{ tag }}
          </span>
        }
        @if (hasMore()) {
          <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium text-stone-400 border border-stone-200 bg-stone-50 whitespace-nowrap">
            +{{ tags().length - max }}
          </span>
        }
      </div>
    }
  `
})
export class TagChipsComponent {
  @Input() set value(v: string | null | undefined) { this._value.set(v || ''); }
  @Input() max = 2;

  private _value = signal('');

  tags = computed<string[]>(() =>
    this._value() ? this._value().split(',').map(t => t.trim()).filter(Boolean) : []
  );

  visibleTags = computed(() => this.tags().slice(0, this.max));
  hasMore     = computed(() => this.tags().length > this.max);
}
